import { DeploymentStatus } from '@/common/constants/deployment.constants';
import { NotificationType } from '@/common/constants/common.constants';
import i18n from '@/common/i18n';
import { useNotifications } from '@/common/utils/notifications/notificationsPlugin';

const getDeploymentNotification = (status: DeploymentStatus, deploymentName: string) => ({
  [DeploymentStatus.RUNNING]: {
    type: NotificationType.INFO,
    title: i18n.t('Deployment started'),
    message: i18n.t('New deployment started')
  },
  [DeploymentStatus.COMPLETED]: {
    type: NotificationType.SUCCESS,
    title: i18n.t('Deployment completed'),
    message: i18n.t('Deployment "{name}" successfully completed', { name: deploymentName })
  },
  [DeploymentStatus.ERROR]: {
    type: NotificationType.ERROR,
    title: i18n.t('Deployment failed'),
    message: i18n.t('Deployment "{name}" failed', { name: deploymentName })
  },
  [DeploymentStatus.CANCELED]: {
    type: NotificationType.INFO,
    title: i18n.t('Deployment canceled'),
    message: i18n.t('Deployment "{name}" canceled', { name: deploymentName })
  }
}[status]);

export const notifyDeploymentStatusChange = (
  status: DeploymentStatus | undefined,
  deploymentId: string,
  deploymentName: string
) => {
  if (!status) return;

  const notification = getDeploymentNotification(status, deploymentName);
  if (!notification) return;

  const { notify } = useNotifications();
  notify({
    type: notification.type,
    title: notification.title,
    message: notification.message,
    operationId: `deployment-${status}-${deploymentId}`,
    showBottom: true
  });
};
